import colors from '@core/utils/colors';
import vars from '@/styles/vars.icss.scss';

export default colors(vars);
